import { Injectable } from "@angular/core";
import { StorageService } from 'src/app/app.storage.service';
import { Constants } from 'src/app/app.constants';

@Injectable({
    providedIn: "root"
})

export class AuthService{
    constructor(private storageService: StorageService){}

    setAccessToken(tokenDetails: any){
        if(tokenDetails){
            localStorage.clear();
            localStorage.setItem("accessToken", tokenDetails);
        }
    }

    getAccessToken(){
        let userData = this.storageService.getDataFromLocalStorage("userData");
        if(userData && userData.accessToken){
            return userData.accessToken;
        }
        return null;
        // return localStorage.getItem("accessToken");
    }

    isLoggedIn(){
        let accessToken = this.getAccessToken();
        if(accessToken){
            return true;
        }
        return false;
        // if(localStorage.getItem("accessToken")){
        //     return true;
        // }
        // return false;
    }

    getLogo(){
        let logo = this.storageService.getDataFromLocalStorage("logo");
        if(logo){
            return Constants.COMPANY_IMG_URL + "images/" +logo;
            // return "http://workmate.mapmyindia.com/betaTest/images/logo_1532428323144_download.jpg";
        }
        return null;
    }
    getHeaders(){
        let switchUserId = this.storageService.getDataFromLocalStorage("switchUserId");
        var headers = {};
        headers['Authorization'] = "Bearer " + this.getAccessToken();
        if(switchUserId){
            headers['userId'] = switchUserId;
        }
        return headers;

    }
}